import Button from "@app/sharedComponents/Button/Button"
import { ThemedText, ThemedView } from "@app/theme"
import { Image, Platform } from "react-native"


const DATA = [
    {
        title: "Check eligible credit limit",
        description: "Get you offer basis your holdings in 15s and accept your offer!",
        image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png"
    },
    {
        title: "Complete Application",
        description: "Complete the application to open a new loan account!",
        image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verify_interest_charges.png"
    },
    {
        title: "Request Withdrawal",
        description: "Request for funds as needed and receive the funds in a few minutes!",
        image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/withdraw_cash.png"
    }
]

const HowItWorks = ({ closeBottomSheet }: { closeBottomSheet: () => void }) => {
    return (
        <ThemedView backgroundColor="bg-surface-primary" p="lg" pt="2xl" >
            <ThemedText variant="h4s" color="text-primary" mb="2xl">Unlock more limit in just 3 steps</ThemedText>

            {DATA.map((item, index) => (
                <ThemedView mb="2xl" flexDirection="row" alignItems="center" key={index}>
                    {index < DATA.length - 1 && (
                        <ThemedView position="absolute" height={50} width={1} top={'95%'} left={19} bg="border-secondary" />
                    )}
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        <Image source={{ uri: item.image }} style={{ width: 40, height: 40 }} />
                    </ThemedView>
                    <ThemedView ml="md" flex={1} flexWrap={Platform.OS !== 'web' ? 'nowrap' : 'wrap'}>
                        <ThemedText variant="b3s" color="text-primary">{item.title}</ThemedText>
                        <ThemedText variant="b3r" color="text-secondary">
                            {item.description}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            ))}

            <Button label="Ok, got it!" handlePress={closeBottomSheet} />
        </ThemedView>
    )
}

export default HowItWorks